import { Button, Col, Row, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import SearchControl from "../../../../../../../../components/SearchControls/SearchGroups/SearchControl";
import styles from "./style.scss";
import { getIconUrl } from "../../../../../../../../services/asset";
import {
  CategoryNameHr,
  ControlType,
  DataSource,
  LocalStorageKey
} from "../../../../../../../../models";
import history from "../../../../../../../../history";

const MobileSearchGroup = props => {
  const { groupConfig, form, onSubmit, onReset, isMobile, showAllControls, maxWidth, hideSearchButton } = props;

  const handleSubmit = () => {
    const { onSubmit } = props;

    onSubmit();
  };

  const renderSearchBtn = onClick => {
    return (
      <Button
        type="primary"
        className={`uppercase ${styles.searchButton}`}
        onClick={onClick}
      >
        <img
          alt={"Traži"}
          src={getIconUrl("search-white.svg")}
        />
        {"Traži"}
      </Button>
    );
  };

  return (
    <div style={{ maxWidth }}>
      <Row style={{ width: "100%" }}>
        <Row type="flex" gutter={24}>
          {groupConfig.controls.map((controlConfig, index) => (
            <Col
              key={index}
              span={24}
              style={{ marginBottom: "10px" }}
            >
              <SearchControl
                key={index}
                form={form}
                controlConfig={controlConfig}
                isMobile={isMobile}
                onSubmit={onSubmit}
                showPlaceholder={true}
                showAllControls={showAllControls}
                isSearch={true}
              />
            </Col>
          ))}
          {!showAllControls && !hideSearchButton && (
            <Col span={24} className={styles.searchBtnCol}>
              {onReset && (
                <Tooltip title="Resetiraj filtere">
                  <span className={styles.resetBtn} onClick={onReset}>
                    <img alt="Resetiraj" src={getIconUrl("reload.svg")} />
                  </span>
                </Tooltip>
              )}
              {renderSearchBtn(handleSubmit)}
            </Col>
          )}
        </Row>
      </Row>
    </div>
  );
};

export default MobileSearchGroup;



// WEBPACK FOOTER //
// ./src/containers/ModulePage/SubLevel1/SubLevel1Desktop/FilterSection/SearchControls/SearchGroups/MobileSearchGroup/index.tsx